import React from "react"
import {graphql, Link, useStaticQuery} from "gatsby"

import Footer from "./footer"
import "./global.css"
import Image from "gatsby-image";

const Layout = ({ location, title, children }) => {

  const data = useStaticQuery(graphql`
      query sidebarQuery {
          logo: file(relativePath: { regex: "/sebastix-logo.png/" }) {
              childImageSharp {
                  fluid(maxWidth: 280, quality: 90) {
                      ...GatsbyImageSharpFluid_noBase64
                      ...GatsbyImageSharpFluidLimitPresentationSize
                  }
              }
          }
      }
  `)

  const header = (
    <>
      <h2>
        <Link
          style={{
            boxShadow: `none`,
            color: `inherit`,
          }}
          to={`/`}
        >
          blog
        </Link>
      </h2>
    </>
  )

  return (
    <div
      style={{
        backgroundColor: "var(--bg)",
        color: "var(--textNormal)",
        transition: "color 0.2s ease-out, background 0.2s ease-out",
        minHeight: "100vh",
      }}
    >
      <div className="sidebar">
        <div className="md:h-screen flex flex-col justify-center items-center">
          <Link to={`/`} className={`logo`}>
            <Image
              fluid={data.logo.childImageSharp.fluid}
              alt={title}
            />
          </Link>
          {header}
          <br />
          <div>
            <a href="https://nostr.com/npub1qe3e5wrvnsgpggtkytxteaqfprz0rgxr8c3l34kk3a9t7e2l3acslezefe"
               style={{
                 boxShadow: "none",
                 margin: "0 10px"
               }}
               target={`_blank`}
               title="Nostr"
               className="nostr">
              <svg viewBox="0 0 16 16" width="27" height="32" xmlns="http://www.w3.org/2000/svg" className="bi bi-nostr">
                <g fill="#FFFFFF">
                  <path d="M1341.73 359.738C1338.13 324.538 1326.53 292.738 1304.13 264.938C1284.33 240.338 1258.93 222.738 1234.93 202.938C1222.93 193.138 1191.13 166.538 1187.13 151.538C1182.33 133.338 1189.73 114.738 1206.33 108.738C1231.33 100.338 1273.13 100.538 1297.33 102.138C1317.93 103.738 1339.13 96.5377 1339.93 88.1377C1340.73 79.7377 1328.53 67.3377 1312.33 63.5377C1299.53 60.5377 1279.93 55.9377 1268.13 48.1377C1247.13 33.9377 1225.73 7.93768 1196.53 2.13768C1154.93 -6.06232 1125.93 9.53768 1112.33 45.3377C1090.73 96.5377 1104.73 162.138 1150.13 210.138C1170.53 231.738 1194.33 250.338 1217.13 269.738C1233.93 284.138 1248.73 299.938 1262.93 317.538C1300.93 364.938 1260.73 451.938 1251.13 461.938C1217.53 496.738 1188.33 503.138 1130.33 500.738C1073.33 498.338 925.525 421.938 847.325 419.538C653.725 413.538 519.325 502.938 473.925 526.138C405.925 560.938 309.125 563.138 306.125 564.138C262.325 567.538 171.525 570.938 126.525 586.538C63.1252 604.138 28.9252 633.138 5.7252 697.938C-1.4748 725.938 -2.87477 751.338 7.32523 766.738C29.5252 800.338 89.3252 828.338 116.525 843.738C130.525 851.738 158.125 841.738 163.525 837.938C193.925 817.338 220.725 801.138 256.725 795.938C264.325 794.738 315.125 785.738 340.725 804.538C359.325 818.138 375.325 826.338 396.325 835.938C434.725 853.338 519.325 875.338 520.925 875.738C532.325 878.738 546.925 884.538 546.925 894.738C546.925 909.138 412.525 1021.54 405.125 1024.34C371.325 1038.14 351.725 1060.34 345.525 1092.34C343.525 1102.74 338.925 1113.54 333.125 1122.14C311.325 1153.74 214.725 1290.94 189.125 1328.54C176.925 1346.14 164.325 1354.94 146.925 1357.74C121.925 1361.74 103.125 1362.34 92.5252 1380.14C85.9252 1391.54 90.1252 1413.74 94.5252 1428.14C99.5252 1444.54 85.9252 1464.94 84.9252 1467.34C72.9252 1490.74 67.9252 1513.14 69.7252 1535.74C70.3252 1544.94 70.9252 1566.34 86.1252 1566.94C101.325 1567.74 105.325 1557.94 107.125 1554.34C109.325 1549.94 117.725 1531.74 120.125 1527.34C129.925 1509.14 167.325 1469.94 171.525 1465.34C184.925 1450.54 384.925 1175.14 384.925 1175.14C395.925 1160.74 407.325 1145.94 425.925 1138.74C451.725 1128.74 468.925 1108.14 473.925 1080.94C475.125 1074.94 554.925 1013.74 588.925 987.938C601.325 978.538 676.525 948.338 677.725 948.738C677.725 949.338 608.925 1052.94 587.525 1107.94C584.125 1116.74 578.525 1146.74 584.725 1161.94C594.325 1185.34 614.925 1195.54 638.325 1188.54C645.525 1186.34 651.925 1182.74 658.125 1179.34C660.925 1177.74 663.725 1176.34 666.525 1174.94C669.325 1173.54 671.925 1172.14 674.725 1170.74C681.125 1167.34 687.325 1164.14 693.525 1162.14C716.525 1154.54 739.725 1147.34 762.925 1140.14L809.925 1125.54C842.725 1115.34 875.525 1105.14 908.325 1095.14C915.525 1092.94 922.525 1090.34 931.525 1090.54C936.525 1090.54 941.925 1092.54 943.725 1099.94C943.725 1100.34 947.525 1122.74 961.325 1131.74C968.325 1136.34 983.325 1139.94 994.525 1139.54C1004.33 1139.14 1016.73 1141.94 1023.13 1147.54L1031.33 1154.54C1037.33 1159.54 1044.73 1162.34 1049.73 1163.74C1054.93 1165.14 1064.53 1165.14 1070.13 1159.34C1076.13 1152.94 1073.93 1142.54 1073.13 1139.34C1071.93 1134.94 1069.53 1131.54 1067.73 1128.54L1062.73 1120.74C1057.93 1113.14 1053.33 1105.54 1048.33 1097.94C1034.53 1076.94 1020.93 1056.14 1006.93 1035.34C992.325 1013.74 969.725 1005.14 940.125 1009.74C928.725 1011.54 678.525 1089.14 676.725 1089.54C690.125 1064.94 770.325 954.138 792.725 940.138C809.325 930.338 816.325 920.938 846.525 915.738C905.525 905.738 1033.53 876.138 1065.33 853.138C1127.13 808.338 1132.13 706.538 1131.13 686.138C1129.93 665.738 1136.53 651.738 1154.33 642.338C1163.13 637.738 1258.33 585.138 1304.93 507.538C1332.93 462.138 1347.33 413.538 1341.73 359.738Z" fill="white"/>
                </g>
              </svg>
            </a>
            <a rel="me" href="https://nwb.social/@sebastian" target={`_blank`}
               style={{
                 boxShadow: "none",
                 margin: "0 10px"
               }} title="https://nwb.social/@sebastian">
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#FFF"
                   viewBox="0 0 16 16">
                <path
                  d="M11.19 12.195c2.016-.24 3.77-1.475 3.99-2.603.348-1.778.32-4.339.32-4.339 0-3.47-2.286-4.488-2.286-4.488C12.062.238 10.083.017 8.027 0h-.05C5.92.017 3.942.238 2.79.765c0 0-2.285 1.017-2.285 4.488l-.002.662c-.004.64-.007 1.35.011 2.091.083 3.394.626 6.74 3.78 7.57 1.454.383 2.703.463 3.709.408 1.823-.1 2.847-.647 2.847-.647l-.06-1.317s-1.303.41-2.767.36c-1.45-.05-2.98-.156-3.215-1.928a3.614 3.614 0 0 1-.033-.496s1.424.346 3.228.428c1.103.05 2.137-.064 3.188-.189zm1.613-2.47H11.13v-4.08c0-.859-.364-1.295-1.091-1.295-.804 0-1.207.517-1.207 1.541v2.233H7.168V5.89c0-1.024-.403-1.541-1.207-1.541-.727 0-1.091.436-1.091 1.296v4.079H3.197V5.522c0-.859.22-1.541.66-2.046.456-.505 1.052-.764 1.793-.764.856 0 1.504.328 1.933.983L8 4.39l.417-.695c.429-.655 1.077-.983 1.934-.983.74 0 1.336.259 1.791.764.442.505.661 1.187.661 2.046v4.203z" fill="#FFF" />
              </svg>
            </a>
          </div>
        </div>
      </div>

      <div className="main-content relative">
        <main>{children}</main>
        <Footer />
      </div>
    </div>
  )
}

export default Layout
